<template>
  <fab-button @click="openNewTicketPage">
    add
  </fab-button>
</template>

<script>
import FabButton from "./FabButton";

export default {
  components: {
    FabButton,
  },
  methods: {
    openNewTicketPage() {
      this.$router.replace("/newticket");
    }
  }
};
</script>

<style lang="scss" scoped>
@use "../assets/scss/variables" as v;

.fab-button {
  background: v.$g4t-blue !important;
  color: white !important;
}
</style>
